module.exports = __webpack_public_path__ + "img/Noaccess.96b17c5b.png";